import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'framework-ui-components';

const LoadingPanel = ({ children, isLoading }) => (
    <div className="loadingPanel__container">
        {isLoading
            && (
                <div className="loadingPanel">
                    <Spinner large />
                </div>
            )}
        {children}
    </div>
);

LoadingPanel.propTypes = {
    children: PropTypes.element,
    isLoading: PropTypes.bool.isRequired,
};

export default LoadingPanel;
